/* ═══ FM HEADER JS (d103b · paso 6 mudanza inline→asset) ═══
   Antes eran 4 <script> inline en sections/header.liquid. Mismo contenido y MISMO ORDEN.
   Se carga SIN defer/async en la posición del script del cajón (tras su markup):
   el cajón hace getElementById de nodos que se pintan justo antes.
   1) FLAMENCO CHAT (dispara Shopify Inbox)  2) FMP-CART-DRAWER (__fmpCD)
   3) account-click-fix (d80)  4) search-click-guard */
/* FM · FLAMENCO CHAT — abre Shopify Inbox al pulsar nuestro flamenco cian.
   Inbox no deja poner icono propio en su widget → usamos un disparador propio y
   le pasamos el clic al botón nativo (varios selectores, incl. shadow DOM). Oculta
   el bubble nativo por CSS; si NO encontramos el widget tras varios intentos, ponemos
   .fm-inbox-fallback en <html> (reaparece el bubble nativo) y el flamenco enlaza a contacto. */
(function(){
  if (window.__fmChatTrigger) return; window.__fmChatTrigger = true;
  var FALLBACK_URL = '/pages/contacto';
  function nativeButton(){
    // 0) widget MODERNO (2026): <shopify-chat> / <shopify-agent> (web components).
    //    shadow ABIERTO → activador interno; shadow CERRADO → devolvemos el propio host
    //    y fireClick le manda la secuencia pointer (composed:true).
    var agent = document.querySelector('shopify-chat') || document.querySelector('shopify-agent');
    if (agent) {
      if (agent.shadowRoot) {
        var a = agent.shadowRoot.querySelector('[part="activator"], button.activator, button, [role="button"]');
        if (a) return a;
      }
      return agent;
    }
    // 1) botón directo (versión clásica)
    var b = document.querySelector('#ShopifyChat button[aria-controls="chat-ui"]');
    if (b) return b;
    // 2) toggle dentro del shadow DOM (versión anterior)
    var host = document.querySelector('#ShopifyChat');
    if (host && host.shadowRoot) {
      var t = host.shadowRoot.querySelector('.chat-toggle, button[aria-controls], button');
      if (t) return t;
    }
    // 3) iframe dummy del launcher
    var ifr = document.querySelector('#dummy-chat-button-iframe');
    if (ifr) {
      try { var inB = ifr.contentWindow.document.querySelector('button'); if (inB) return inB; } catch(e){}
      return ifr; // clicar el iframe igualmente
    }
    return null;
  }
  function inboxPresent(){
    return !!(document.querySelector('shopify-chat') || document.querySelector('shopify-agent') || document.querySelector('#shopify-chat-app-embed-data') || document.querySelector('#ShopifyChat') || document.querySelector('#shopify-chat') || document.querySelector('#dummy-chat-button-iframe'));
  }
  function fireClick(el){
    // El widget moderno escucha pointer/mouse events (un .click() sintético a secas
    // NO abre el panel) → secuencia completa con composed:true (cruza el shadow).
    try {
      var types = ['pointerdown','mousedown','pointerup','mouseup','click'];
      for (var i = 0; i < types.length; i++) {
        var Ev = (types[i].indexOf('pointer') === 0 && window.PointerEvent) ? PointerEvent : MouseEvent;
        el.dispatchEvent(new Ev(types[i], { bubbles: true, composed: true, cancelable: true }));
      }
      return true;
    } catch(err){
      try { el.click(); return true; } catch(err2){ return false; }
    }
  }
  function init(){
    var trigger = document.getElementById('fmChatTrigger');
    if (!trigger) return;
    trigger.addEventListener('click', function(e){
      var btn = nativeButton();
      if (!btn) { window.location.href = FALLBACK_URL; return; }
      // stopPropagation + setTimeout: que el click REAL del flamenco no llegue al
      // listener "clic fuera = cerrar" del widget y cierre el panel recién abierto.
      e.preventDefault();
      e.stopPropagation();
      setTimeout(function(){ if (!fireClick(btn)) window.location.href = FALLBACK_URL; }, 40);
    });
    // Espera a que Inbox cargue (script asíncrono). Si tras ~6s no aparece, activa fallback.
    var tries = 0, max = 60; // 60 * 250ms = 15s (el embed moderno puede tardar en conexiones lentas)
    var poll = setInterval(function(){
      tries++;
      if (inboxPresent()) { clearInterval(poll); document.documentElement.classList.remove('fm-inbox-fallback'); }
      else if (tries >= max) { clearInterval(poll); document.documentElement.classList.add('fm-inbox-fallback'); }
    }, 250);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

(function(){
  if(window.__fmpCD) return; window.__fmpCD=true;
  var root=document.getElementById('fmp-cart-drawer'); if(!root) return;
  var bodyEl=document.getElementById('fmp-cd-body'),
      items=document.getElementById('fmp-cd-items'), foot=document.getElementById('fmp-cd-foot'),
      shipEl=document.getElementById('fmp-cd-ship'), subEl=document.getElementById('fmp-cd-sub'),
      sub2El=document.getElementById('fmp-cd-sub2'), countEl=document.getElementById('fmp-cd-count'),
      titleEl=document.getElementById('fmp-cd-title'),
      crossEl=document.getElementById('fmp-cd-cross'), recEl=document.getElementById('fmp-cd-rec'),
      discInput=document.getElementById('fmp-cd-disc-input'), discBtn=document.getElementById('fmp-cd-disc-btn'),
      discMsg=document.getElementById('fmp-cd-disc-msg'), appliedEl=document.getElementById('fmp-cd-applied');
  var THRESHOLD=parseInt(root.getAttribute('data-fmp-threshold'),10)||0;

  function money(c){ return (c/100).toFixed(2).replace('.',',')+' €'; }
  function esc(s){ return (''+(s==null?'':s)).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];}); }
  function open(){ root.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function close(){ root.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
  function updateCount(n){
    var sel=['[data-cart-count]','.cart-count','.cart-link__count','.js-cart-count','.header-cart-count','.cart-item-count'];
    document.querySelectorAll(sel.join(',')).forEach(function(el){ el.textContent=n; });
  }
  function renderShip(total){
    if(!THRESHOLD){ shipEl.style.display='none'; return; }
    shipEl.style.display='';
    var rem=THRESHOLD-total, pct=Math.min(100, Math.round(total*100/THRESHOLD));
    shipEl.innerHTML=(rem>0?'Te faltan <b>'+money(rem)+'</b> para el <b>envío gratis</b>':'🎉 ¡Tienes <b>envío gratis</b>!')
      +'<div class="fmp-cd__ship-track"><div class="fmp-cd__ship-fill" style="width:'+pct+'%"></div></div>';
  }
  function lineHTML(it){
    var img=it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2') : '';
    var opts=(it.options_with_values||[]).filter(function(o){return o.value && o.value!=='Default Title';}).map(function(o){return esc(o.value);}).join(' · ');
    var price=(it.original_line_price>it.final_line_price)?'<s>'+money(it.original_line_price)+'</s>'+money(it.final_line_price):money(it.final_line_price);
    return '<div class="fmp-cd__line" data-key="'+esc(it.key)+'">'
      +(img?'<img class="fmp-cd__img" src="'+esc(img)+'" alt="'+esc(it.product_title)+'">':'<div class="fmp-cd__img"></div>')
      +'<div class="fmp-cd__info"><p class="fmp-cd__name">'+esc(it.product_title)+'</p>'
        +(opts?'<p class="fmp-cd__opt">'+opts+'</p>':'')
        +'<div class="fmp-cd__row2"><span class="fmp-cd__qty">'
          +'<button type="button" class="fmbtn fmbtn--round" data-fmp-dec aria-label="Restar"><span>−</span></button>'
          +'<span class="n">'+it.quantity+'</span>'
          +'<button type="button" class="fmbtn fmbtn--round" data-fmp-inc aria-label="Sumar"><span>+</span></button></span>'
        +'<span class="fmp-cd__price">'+price+'</span></div></div>'
      +'<button type="button" class="fmp-cd__rm" data-fmp-rm aria-label="Quitar"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg></button></div>';
  }
  function cardHTML(p){
    var img=p.featured_image ? (''+p.featured_image).replace(/(\.[a-z]+)(\?|$)/i,'_240x$1$2') : '';
    var pr=(p.price!=null)?money(p.price):((p.price_min!=null)?money(p.price_min):'');
    var multi=(p.variants&&p.variants.length>1)?1:0, vid=(p.variants&&p.variants[0])?p.variants[0].id:'';
    return '<div class="fmp-cd__card" data-url="'+esc(p.url)+'" data-vid="'+esc(vid)+'" data-multi="'+multi+'">'
      +'<div class="fmp-cd__card-img"'+(img?' style="background-image:url('+esc(img)+')"':'')+'>'
        +'<a class="fmp-cd__card-link" href="'+esc(p.url)+'" aria-label="'+esc(p.title)+'"></a>'
        +'<button type="button" class="fmbtn fmbtn--round fmp-cd__card-add" data-fmp-recadd aria-label="Añadir"><span>+</span></button></div>'
      +'<a class="fmp-cd__card-name" href="'+esc(p.url)+'">'+esc(p.title)+'</a>'
      +'<span class="fmp-cd__card-price">'+pr+'</span></div>';
  }
  // Sugerencias: SIEMPRE de OTRA categoría (complementar el look). related devuelve misma
  // categoría y complementary está vacío → tiramos de colecciones complementarias por tipo.
  var COMPLEMENTS={
    'trajes de baño':['camisetas','paws-collection','guayaberas-yatch-collection','gorras','camisas-de-lino'],
    'camisetas':['banadores-hombre','gorras','hombre-calzoncillos-men-boxers-cool-homewear','calcetines-socks'],
    'polos':['banadores-hombre','gorras','camisas-de-lino','calcetines-socks'],
    'sudadera':['banadores-hombre','gorras','hombre-calzoncillos-men-boxers-cool-homewear'],
    'camisas de lino':['banadores-hombre','gorras','paws-collection'],
    'guayabera':['banadores-hombre','gorras','camisas-de-lino'],
    'boxers':['camisetas','banadores-hombre','calcetines-socks'],
    'ropa interior':['camisetas','banadores-hombre','calcetines-socks'],
    'calcetines':['camisetas','banadores-hombre','hombre-calzoncillos-men-boxers-cool-homewear'],
    'pijamas':['camisetas','hombre-calzoncillos-men-boxers-cool-homewear','banadores-hombre'],
    'toallas':['banadores-hombre','camisetas','gorras'],
    'ropa y accesorios':['camisetas','banadores-hombre','paws-collection']
  };
  function normCol(p){
    var vs=(p.variants||[]), v0=vs[0]||{};
    var cents=(v0.price!=null)?Math.round(parseFloat(v0.price)*100):null;
    return { id:p.id, title:p.title, url:'/products/'+p.handle,
      featured_image:(p.images&&p.images[0]&&p.images[0].src)||'', price:cents,
      variants:vs.map(function(v){return {id:v.id};}) };
  }
  function renderRecs(c){
    if(!c.items||!c.items.length){ crossEl.style.display='none'; return; }
    var exId={}, exType={}, order=[];
    c.items.forEach(function(it){ exId[it.product_id]=1; var t=(it.product_type||'').toLowerCase(); exType[t]=1; if(order.indexOf(t)<0)order.push(t); });
    var handles=null;
    for(var i=0;i<order.length && !handles;i++){ if(COMPLEMENTS[order[i]]) handles=COMPLEMENTS[order[i]]; }
    if(!handles) handles=['camisetas','banadores-hombre','gorras'];
    handles=handles.slice(0,3);
    Promise.all(handles.map(function(h){
      return fetch('/collections/'+h+'/products.json?limit=12',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.ok?r.json():{products:[]};}).catch(function(){return {products:[]};});
    })).then(function(res){
      var lists=res.map(function(d){return (d.products||[]);});
      var out=[], seen={}, idx=0, guard=0;
      while(out.length<8 && guard<60){
        var any=false;
        for(var k=0;k<lists.length && out.length<8;k++){
          var p=lists[k][idx];
          if(p){ any=true;
            if(!exId[p.id] && !seen[p.id] && !exType[(p.product_type||'').toLowerCase()]){ seen[p.id]=1; out.push(normCol(p)); }
          }
        }
        if(!any && idx>0) break;
        idx++; guard++;
      }
      if(!out.length){ crossEl.style.display='none'; return; }
      recEl.innerHTML=out.map(cardHTML).join(''); crossEl.style.display='';
    }).catch(function(){ crossEl.style.display='none'; });
  }
  function render(cart){
    var done=function(c){
      if(!c || typeof c.item_count==='undefined'){ return; }
      updateCount(c.item_count);
      if(titleEl) titleEl.textContent = c.item_count>0 ? (c.item_count+(c.item_count===1?' artículo':' artículos')) : 'Tu cesta';
      var empty = !c.items || !c.items.length;
      bodyEl.classList.toggle('is-empty', empty);
      if(empty){ items.innerHTML='<div class="fmp-cd__empty">Tu cesta está vacía.</div>'; foot.style.display='none'; shipEl.style.display='none'; crossEl.style.display='none'; return; }
      items.innerHTML=c.items.map(lineHTML).join('');
      foot.style.display='';
      subEl.textContent=money(c.total_price); if(sub2El) sub2El.textContent=money(c.total_price);
      if(countEl) countEl.textContent='('+c.item_count+')';
      renderShip(c.total_price);
      var _apps=c.cart_level_discount_applications||[];
      if(appliedEl) appliedEl.innerHTML=_apps.map(function(a){ return '<span class="fmp-cd__chip">'+esc(a.title)+'<button type="button" data-fmp-disc-clear aria-label="Quitar código">&times;</button></span>'; }).join('');
      renderRecs(c);
    };
    if(cart) return done(cart);
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json();}).then(done).catch(function(){});
  }
  function change(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){ if(c && typeof c.item_count!=='undefined'){ render(c); } else { render(); } })
      .catch(function(){ render(); });
  }

  document.addEventListener('submit', function(ev){
    var form=ev.target; if(!form||form.tagName!=='FORM') return;
    var action=form.getAttribute('action')||''; if(action.indexOf('/cart/add')===-1) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var btn=form.querySelector('[data-add-to-cart],[name="add"]'); if(btn) btn.setAttribute('disabled','disabled');
    fetch('/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ if(btn) btn.removeAttribute('disabled'); render(); open(); })
      .catch(function(){ if(btn) btn.removeAttribute('disabled'); form.submit(); });
  }, true);

  document.addEventListener('click', function(ev){
    var t=ev.target;
    if(t.closest && t.closest('[data-fmp-cd-close]')){ ev.preventDefault(); close(); return; }
    var a=t.closest && t.closest('a[href]'); if(!a) return;
    var href=(a.getAttribute('href')||'').split('#')[0];
    if(/\/cart(\?|$)/.test(href) && href.indexOf('/cart/')===-1 && a.id!=='fmp-cd-checkout'){ ev.preventDefault(); open(); render(); }
  }, false);

  items.addEventListener('click', function(ev){
    var inc=ev.target.closest&&ev.target.closest('[data-fmp-inc]'),
        dec=ev.target.closest&&ev.target.closest('[data-fmp-dec]'),
        rm=ev.target.closest&&ev.target.closest('[data-fmp-rm]');
    if(!inc&&!dec&&!rm) return;
    ev.preventDefault(); ev.stopPropagation();
    var line=ev.target.closest('.fmp-cd__line'); if(!line) return;
    var key=line.getAttribute('data-key'), qtySpan=line.querySelector('.fmp-cd__qty .n');
    var q=parseInt(qtySpan?qtySpan.textContent:'1',10)||1;
    if(inc) change(key,q+1); else if(dec) change(key,Math.max(0,q-1)); else change(key,0);
  });

  recEl.addEventListener('click', function(ev){
    var add=ev.target.closest && ev.target.closest('[data-fmp-recadd]'); if(!add) return;
    ev.preventDefault(); ev.stopPropagation();
    var card=add.closest('.fmp-cd__card'); if(!card) return;
    if(card.getAttribute('data-multi')==='1'){ window.location.href=card.getAttribute('data-url'); return; }
    var vid=card.getAttribute('data-vid'); if(!vid){ window.location.href=card.getAttribute('data-url'); return; }
    add.innerHTML='<span>✓</span>';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:vid,quantity:1})})
      .then(function(r){return r.json();}).then(function(){ render(); }).catch(function(){ add.innerHTML='<span>+</span>'; });
  });

  function applyDisc(){
    var code=(discInput.value||'').trim(); if(!code){ discMsg.textContent='Escribe un código.'; discMsg.className='fmp-cd__disc-msg err'; return; }
    discMsg.textContent='Comprobando…'; discMsg.className='fmp-cd__disc-msg';
    fetch('/discount/'+encodeURIComponent(code)+'?redirect=/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(c){
        if(c.total_discount>0 || (c.cart_level_discount_applications||[]).length){ discMsg.textContent='¡Código aplicado! ✓'; discMsg.className='fmp-cd__disc-msg ok'; render(c); }
        else { discMsg.textContent='No pudimos aplicar “'+code+'”. Revisa que sea válido.'; discMsg.className='fmp-cd__disc-msg err'; }
      }).catch(function(){ discMsg.textContent='No se pudo comprobar el código.'; discMsg.className='fmp-cd__disc-msg err'; });
  }
  discBtn.addEventListener('click', applyDisc);
  discInput.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); applyDisc(); } });
  if(appliedEl) appliedEl.addEventListener('click', function(ev){
    var cb=ev.target.closest&&ev.target.closest('[data-fmp-disc-clear]'); if(!cb) return;
    ev.preventDefault(); ev.stopPropagation();
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({discount:''})}).then(function(r){return r.json();})
      .then(function(cart){ if(discInput)discInput.value=''; if(discMsg){discMsg.textContent='';discMsg.className='fmp-cd__disc-msg';} render(cart); }).catch(function(){ render(); });
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && root.getAttribute('aria-hidden')==='false') close(); });

  render();
})();

/* CUENTA (d80): el tema cancela el clic del icono en escritorio
   (onAccountIconClick → evt.preventDefault() si width>=768) y solo alterna un
   desplegable, así que pulsarlo parecía no hacer nada. Aquí navegamos de verdad.
   Va en fase de CAPTURA porque el handler del tema es delegado en bubbling:
   stopPropagation aquí evita que llegue a cancelarlo. El desplegable por hover
   sigue funcionando igual. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('.customer-account__parent-link');
    if (!a) return;
    e.stopPropagation();
    var href = a.getAttribute('href');
    window.location.href = href && href.length ? href : '/account';
  }, true);
})();

/* Click en un resultado del buscador: el mousedown roba el foco al input → searchFocusOut (theme.js)
   cierra el desplegable a los 100ms y el click aterriza en el vacío. preventDefault en pointerdown
   conserva el foco (Chrome entonces suprime el click de compatibilidad) → navegamos nosotros en
   pointerup sobre el mismo enlace. Cmd/Ctrl/middle-click quedan nativos (pestaña nueva). */
(function () {
  var hit = function (e) { return e.target && e.target.closest && e.target.closest('.search-bar__results a[href]'); };
  var modified = function (e) { return e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey; };
  document.addEventListener('pointerdown', function (e) {
    if (hit(e) && !modified(e)) e.preventDefault();
  }, true);
  document.addEventListener('pointerup', function (e) {
    var a = hit(e);
    if (a && !modified(e)) { e.preventDefault(); window.location.href = a.href; }
  }, true);
})();
